const ONE_THOUSAND = 1000;

export class Duration {
  readonly #milliseconds: number;

  private constructor(milliseconds: number) {
    this.#milliseconds = milliseconds;
  }

  static fromSeconds(seconds: number | Duration): Duration {
    if (seconds instanceof Duration) {
      return seconds;
    }
    return new Duration(seconds * ONE_THOUSAND);
  }

  private get seconds() {
    return this.#milliseconds / ONE_THOUSAND;
  }

  get human(): string {
    return `${this.seconds}s`;
  }

  static fromMilliseconds(milliseconds: number): Duration {
    return new Duration(milliseconds);
  }
}
